import React, { useContext, HTMLAttributes, forwardRef } from 'react';
import { HeadingLevelContext } from '../context';

export type ElementProps = HTMLAttributes<HTMLDivElement>;
export interface Props {
  tag?: keyof React.JSX.IntrinsicElements;
}

const HeadingLevelBoundary = forwardRef<HTMLDivElement, Props & ElementProps>(
  ({ tag, children, ...rest }, ref) => {
    const headingLevel = useContext(HeadingLevelContext);
    const Tag: any = tag;
    return Tag ? (
      <HeadingLevelContext.Provider value={headingLevel + 1}>
        <Tag {...rest} ref={ref}>
          {children}
        </Tag>
      </HeadingLevelContext.Provider>
    ) : (
      <HeadingLevelContext.Provider value={headingLevel + 1}>
        {children}
      </HeadingLevelContext.Provider>
    );
  }
);
HeadingLevelBoundary.displayName = 'HeadingLevelBoundary';

export default HeadingLevelBoundary;
